import { createSceneReducer } from 'reducers/reducers-util';
import featuredItemsDataReducer from 'components/admin/featured-items/store/reducers.data';

export default createSceneReducer(featuredItemsDataReducer);
